import React from 'react';
import { Link, useLocation } from 'react-router-dom';

interface TabLayoutProps {
  children: React.ReactNode;
}

const TabLayout: React.FC<TabLayoutProps> = ({ children }) => {
  const location = useLocation();
  const isActive = (path: string) => location.pathname.startsWith(path);

  const tabs = [
    { path: '/home', label: 'Home' },
    { path: '/reading', label: 'Reading' },
    { path: '/user', label: 'User' }
  ];

  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: '#050508' }}>
      <div className="flex-1">{children}</div>
      <nav className="sticky bottom-0 w-full z-50">
        <div className="glass-grain border-t backdrop-blur-xl" style={{
          borderColor: 'rgba(255, 184, 79, 0.2)',
          backgroundColor: 'rgba(20, 20, 32, 0.4)',
          boxShadow: '0 -8px 32px rgba(0,0,0,0.4)'
        }}>
          <div className="max-w-3xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-around">
            {tabs.map((tab) => {
              const active = isActive(tab.path);
              return (
                <Link
                  key={tab.path}
                  to={tab.path}
                  className={`
                    relative px-4 py-2.5 rounded-xl font-heading text-sm sm:text-base tracking-luxury-tight
                    transition-all duration-300
                    ${active 
                      ? 'text-cosmic-gold' 
                      : 'text-text-secondary hover:text-text-primary'
                    }
                  `}
                  style={{
                    backgroundColor: active ? 'rgba(255, 184, 79, 0.1)' : 'transparent',
                    border: active ? '1px solid rgba(255, 184, 79, 0.3)' : '1px solid transparent',
                    boxShadow: active ? '0 0 15px rgba(255, 184, 79, 0.2)' : 'none'
                  }}
                >
                  {tab.label}
                  {active && (
                    <div 
                      className="absolute -bottom-1 left-1/2 transform -translate-x-1/2 w-1 h-1 rounded-full"
                      style={{
                        backgroundColor: '#FFB84F',
                        boxShadow: '0 0 8px rgba(255, 184, 79, 0.8)'
                      }}
                    />
                  )}
                </Link>
              );
            })}
          </div>
        </div>
      </nav>
    </div>
  );
};

export default TabLayout;


